import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RoleRouteProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

const RoleRoute: React.FC<RoleRouteProps> = ({ allowedRoles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-brand-accent">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Also grant access if the route allows 'leader' and the user has isLeader flag,
  // since some orgs use a different role string (e.g. 'editor') but flag leaders with isLeader: true.
  const hasAccess =
    allowedRoles.includes(user.role) ||
    (allowedRoles.includes('leader') && !!user.isLeader);

  if (!hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center flex-col gap-3 text-center">
        <span className="text-4xl">🔒</span>
        <p className="text-white font-semibold">Access Restricted</p>
        <p className="text-gray-500 text-sm">Your role ({user.role}) does not have access to this page.</p>
        <a href="/dashboard" className="text-brand-accent underline text-sm">Back to Dashboard</a>
      </div>
    );
  }
  return <>{children}</>;
};

export default RoleRoute;
